import { render, hydrate } from 'react-dom';
import ReactEntryContainer from '../../Page/components/ReactEntryContainer';

import { pushError } from '../../pushError';

import { injectPhpDebug, reactUrlToTransactionName } from '../../mol_function';
import {
  ConsentEnum,
  hasConsent,
} from '../../Page/components/pages/Basepage/parts/CookieManager';

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
let ReactSafeMode = getCookie('ReactSafeMode');

window.ctrlBackup = window.renderCtrItem;

if (ReactSafeMode != '1') {
  try {
    hydrate(<ReactEntryContainer />, document.getElementById('root'));

    window.onerror = function (message, source, lineno, colno, error) {
      if (
        !(
          //IGNORE fontawesome-pro-6.1.1-web-all.min.js Googlebot Problem
          (
            message == 'Uncaught SyntaxError: Invalid or unexpected token' &&
            source ==
              'https://www.moluna.de/public3010/lib/fontawesome-pro-6.1.1-web-all.min.js' &&
            lineno == 2 &&
            (navigator.userAgent.indexOf('Googlebot') > 0 ||
              navigator.userAgent.indexOf('AdsBot-Google-Mobile') > 0)
          )
        )
      )
        pushError('window.onerror', {
          message: message,
          source: source,
          lineno: lineno,
          colno: colno,
          error: error,
        });
    };
  } catch (exception) {
    pushError('hydrate', exception);

    function setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 1 * 60 * 1000); //1 Min
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    setCookie('ReactSafeMode', '1');
    location.reload();
  }
}
